import { render, staticRenderFns } from "./PublicLeadDetails.vue?vue&type=template&id=2e893af6&scoped=true"
import script from "./PublicLeadDetails.vue?vue&type=script&lang=js"
export * from "./PublicLeadDetails.vue?vue&type=script&lang=js"
import style0 from "./PublicLeadDetails.vue?vue&type=style&index=0&id=2e893af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e893af6",
  null
  
)

export default component.exports